import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import classNames from "../pdf.module.scss";
import * as models from "../../../../utils/models";

const PDFSummarySheet = (
  props: models.HelideckSummaryOverview
): JSX.Element => {
  const getMethodResultClassName = (result: string | null): string => {
    if (!result) return classNames.helideckResultText;

    const isPassed: boolean = result.toLowerCase() === "passed";
    return isPassed
      ? classNames.helideckResultTextSuccess
      : classNames.helideckResultTextFail;
  };

  return (
    <div className={classNames["visual-inspection"]}>
      <div className={classNames["visual-inspection-body"]}>
        <div className={classNames["visual-inspection-body-header-warning"]}>
          Result
        </div>
        <div className={classNames["visual-inspection-body-body"]}>
          <p className={classNames.helideckResultText}>
            DRY Method:{" "}
            <span className={getMethodResultClassName(props.dryMethodResult)}>
              {props.dryMethodResult}
            </span>
          </p>
          <p className={classNames.helideckResultText}>
            WET Method:{" "}
            <span className={getMethodResultClassName(props.wetMethodResult)}>
              {props.wetMethodResult}
            </span>
          </p>
        </div>
        <div className={classNames["visual-inspection-body-header-warning"]}>
          General Finding
        </div>
        <div className={classNames["visual-inspection-body-body"]}>
          <p>{props.general}</p>
        </div>
      </div>
      <div className={classNames["visual-inspection-body"]}>
        <div className={classNames["visual-inspection-body-header-danger"]}>
          Remarks & Recommendations:
        </div>
        <div className={classNames["visual-inspection-body-body"]}>
          <p>{props.remarks}</p>
        </div>
      </div>

      <div className="border-horizontal-light">
        <PDFTablePage columns={summaryColumns} data={summaryData} />
      </div>
    </div>
  );
};

export default PDFSummarySheet;

const summaryColumns: models.Column[] = [
  {
    path: "description",
    label: "Description",
    style: () => getColumnStyle(),
  },
  { path: "photoRef", label: "Photo Ref" },
];

const summaryData: any[] = [
  {
    description: "General view of helideck perimeter and flood light fittings.",
    photoRef: "Yes",
  },
  {
    description:
      "View of access stairway on west and east side of the helideck.",
    photoRef: "Yes",
  },
  {
    description: "General view of helideck perimeter and flood light fittings.",
    photoRef: "Yes",
  },
  {
    description: "Personnel drawing gridlines on deck before the test.",
    photoRef: "Yes",
  },
  {
    description: "View showing section of the Helideck with gridline markings",
    photoRef: "Yes",
  },
  {
    description:
      "View of the T2GO friction test machine with the calibration weight hanging freely on front wheel during calibration.",
    photoRef: "Yes",
  },
  {
    description: "Personnel conducting the friction test.",
    photoRef: "Yes",
  },
  {
    description:
      "Personnel spraying water on deck surface for wet condition test.",
    photoRef: "Yes",
  },
  {
    description:
      "General view of helideck surface with water for wet condition test.",
    photoRef: "Yes",
  },
  {
    description:
      "Crash equipment box, fire men cabinet and fire extinguishers on full landing of stairway west side of helideck",
    photoRef: "Yes",
  },
  {
    description:
      "Foam and powder pressure vessel tank connected to hose reel system with nozzles at east and west access to the helideck",
    photoRef: "Yes",
  },
];

const getColumnStyle = (): React.CSSProperties => {
  return { textAlign: "left" };
};
